// AUTO-GENERATED FTP CLIENT PREVIEW SNAPSHOT
// Read-only public content used only when ftpPreviewMode=true and no API host is configured.
// Real API always wins as soon as config.js apiUrl is set.

export const FTP_PREVIEW_DATA = {
  "settings": {
    "site.name": "Bahamas Kidney Association",
    "site.tagline": "A Healthier People. A Stronger Bahamas.",
    "site.phone": "+1 242-436-1317",
    "site.email": "info@bahamaskidneyassociation.org",
    "site.address": "",
    "site.medical_disclaimer": "The information on this website is provided for general education and awareness only. It is not a diagnosis, treatment plan, or personalised medical advice. Always speak with a qualified healthcare professional about your own kidney health. The Bahamas Kidney Association is not an emergency medical service.",
    "donations.fygaro_url": "",
    "emerald.nominations_open": true,
    "emerald.nomination_categories_json": [
      {
        "id": "healthcare-professional",
        "label": "Healthcare Professional",
        "enabled": true,
        "order": 1
      },
      {
        "id": "community-champion",
        "label": "Community Champion",
        "enabled": true,
        "order": 2
      },
      {
        "id": "patient-advocate",
        "label": "Patient Advocate",
        "enabled": true,
        "order": 3
      },
      {
        "id": "volunteer",
        "label": "Volunteer",
        "enabled": true,
        "order": 4
      },
      {
        "id": "organization",
        "label": "Organization",
        "enabled": true,
        "order": 5
      }
    ],
    "emerald.closed_message": "Nominations are currently closed. Please check back soon.",
    "social.facebook_url": "",
    "social.instagram_url": "",
    "social.youtube_url": "",
    "social.linkedin_url": ""
  },
  "nav": [
    {
      "label": "Home",
      "href": "/"
    },
    {
      "label": "About",
      "href": "/about"
    },
    {
      "label": "Kidney Health",
      "href": "/kidney-health"
    },
    {
      "label": "Our Efforts",
      "href": "/our-efforts"
    },
    {
      "label": "Support",
      "href": "/get-support"
    },
    {
      "label": "Blogs",
      "href": "/blog"
    },
    {
      "label": "Emerald Honours",
      "href": "/emerald-honours"
    },
    {
      "label": "Contact",
      "href": "/contact"
    }
  ],
  "pages": [
    {
      "title": "Home",
      "slug": "home",
      "page_type": "home",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/5727792/pexels-photo-5727792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      "seo_title": "Bahamas Kidney Association — Stronger Kidneys. Stronger Bahamas.",
      "seo_description": "The Bahamas Kidney Association raises kidney-health awareness, supports people affected by kidney disease and promotes prevention across The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Healthy People. Brighter Tomorrows.",
          "heading_line_1": "Stronger Kidneys.",
          "heading_line_2": "Stronger Bahamas.",
          "subheading": "Empowering individuals. Supporting families. Building a healthier future for our islands.",
          "primary_cta": {
            "label": "Donate Now",
            "href": "/donate"
          },
          "secondary_cta": {
            "label": "Get Support",
            "href": "/get-support"
          },
          "script_accent": "Healthier Bahamians, Brighter Tomorrows"
        },
        "quick_links": [
          {
            "icon": "users",
            "title": "About Us",
            "text": "Our mission, vision and the people behind our work.",
            "cta": "Learn More",
            "href": "/about"
          },
          {
            "icon": "leaf",
            "title": "Our Efforts",
            "text": "Programs and initiatives making a difference across The Bahamas.",
            "cta": "See Our Work",
            "href": "/our-efforts"
          },
          {
            "icon": "heart-handshake",
            "title": "Get Involved",
            "text": "Be a volunteer, advocate or supporter. Every action matters.",
            "cta": "Join Us",
            "href": "/get-involved"
          },
          {
            "icon": "book-open",
            "title": "Research",
            "text": "Advancing knowledge for better kidney health tomorrow.",
            "cta": "Explore Research",
            "href": "/research"
          }
        ],
        "feature": {
          "eyebrow": "Flagship Program",
          "title": "Medication Assistance Program",
          "text": "Helping individuals access the life-saving medications they need. Because no one should face kidney disease alone.",
          "cta": {
            "label": "Learn About the Program",
            "href": "/programs/medication-assistance-program"
          },
          "image_url": "https://images.pexels.com/photos/5430213/pexels-photo-5430213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
          "note": "Program availability, medicines, eligibility and capacity can change. Please contact us for current details."
        },
        "emerald_panel": {
          "eyebrow": "Emerald Honours",
          "title": "Extraordinary People. A Healthier Bahamas.",
          "text": "Celebrating excellence, leadership, service and community impact.",
          "primary_cta": {
            "label": "Submit a Nomination",
            "href": "/emerald-honours/nominate"
          },
          "secondary_cta": {
            "label": "Watch Videos",
            "href": "/emerald-honours#media"
          },
          "image_url": "https://images.pexels.com/photos/7005756/pexels-photo-7005756.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200"
        },
        "testimonials_heading": "What People Are Saying",
        "posts_heading": "Latest Posts",
        "newsletter": {
          "heading": "Join Our Newsletter",
          "text": "Kidney health awareness, programs and events across The Bahamas."
        }
      },
      "id": "preview-page-1",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "About Us",
      "slug": "about",
      "page_type": "standard",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "seo_title": "About the Bahamas Kidney Association",
      "seo_description": "Founded in April 2021, the Bahamas Kidney Association works to reduce kidney failure and improve the lives of people affected by kidney disease in The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "About Us",
          "heading_line_1": "A Healthier People.",
          "heading_line_2": "A Stronger Bahamas.",
          "subheading": "Our story, our mission and the community we serve."
        },
        "sections": [
          {
            "type": "rich_text",
            "title": "Our Story",
            "body": "The Bahamas Kidney Association was founded in April 2021. Tamika Roberts is publicly identified as a founder and president of the association, and is a living kidney donor. The organisation was inspired by, and carries forward, the kidney-awareness legacy associated with Dr. Ada Thompson."
          },
          {
            "type": "rich_text",
            "title": "Our Mission",
            "body": "Our mission centres on reducing kidney failure and improving the lives of people affected by kidney disease in The Bahamas. We work to increase kidney-health awareness, support people living with kidney disease and their families, and promote prevention across the islands."
          },
          {
            "type": "bullets",
            "title": "What Guides Us",
            "items": [
              {
                "title": "Education",
                "text": "Clear, accurate kidney-health information for every Bahamian."
              },
              {
                "title": "Support",
                "text": "Practical help and guidance for patients and the families who care for them."
              },
              {
                "title": "Prevention",
                "text": "Early detection and awareness so fewer Bahamians reach kidney failure."
              },
              {
                "title": "Community",
                "text": "Partnership with healthcare professionals, schools, and community organisations."
              }
            ]
          },
          {
            "type": "rich_text",
            "title": "Leadership",
            "body": "Leadership and board information will be published here once confirmed by the association. This section is editable in the CMS.",
            "placeholder": true
          },
          {
            "type": "cta",
            "title": "Support Our Mission",
            "text": "Your support helps us reach more Bahamians with education, screening and assistance.",
            "primary": {
              "label": "Donate",
              "href": "/donate"
            },
            "secondary": {
              "label": "Get Involved",
              "href": "/get-involved"
            }
          }
        ]
      },
      "id": "preview-page-2",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Kidney Health",
      "slug": "kidney-health",
      "page_type": "standard",
      "status": "published",
      "hero_image_url": "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "seo_title": "Kidney Health Education | Bahamas Kidney Association",
      "seo_description": "Learn about chronic kidney disease, risk factors, symptoms to discuss with your doctor, kidney-friendly eating and kidney tests such as eGFR and urine albumin.",
      "body_json": {
        "hero": {
          "overline": "Kidney Health",
          "heading_line_1": "Know Your Kidneys.",
          "heading_line_2": "Protect Your Future.",
          "subheading": "Education and awareness for individuals, families and communities across The Bahamas."
        },
        "sections": [
          {
            "type": "disclaimer",
            "title": "Important Medical Disclaimer",
            "body": "The information on this website is provided for general education and awareness only. It is not a diagnosis, treatment plan, or personalised medical advice. Always speak with a qualified healthcare professional about your own kidney health. The Bahamas Kidney Association is not an emergency medical service."
          },
          {
            "type": "rich_text",
            "title": "Chronic Kidney Disease",
            "body": "Chronic kidney disease (CKD) means the kidneys have been damaged and cannot filter blood as well as they should. CKD often develops gradually, and many people do not notice it in the early stages. That is why awareness, routine check-ups and early detection matter so much."
          },
          {
            "type": "bullets",
            "title": "Common Risk Factors",
            "items": [
              {
                "title": "High blood pressure",
                "text": "One of the most common causes of kidney damage."
              },
              {
                "title": "Diabetes",
                "text": "Raised blood sugar over time can damage the kidneys' filters."
              },
              {
                "title": "Family history",
                "text": "Kidney disease in your family can raise your own risk."
              },
              {
                "title": "Age and other conditions",
                "text": "Other long-term health conditions can also affect kidney function."
              }
            ]
          },
          {
            "type": "bullets",
            "title": "Possible Signs to Discuss With a Healthcare Professional",
            "items": [
              {
                "title": "Changes in urination",
                "text": "Changes in how often or how much you pass urine."
              },
              {
                "title": "Swelling",
                "text": "Swelling in the feet, ankles, hands or around the eyes."
              },
              {
                "title": "Ongoing tiredness",
                "text": "Unusual fatigue or weakness that does not improve."
              },
              {
                "title": "Other symptoms",
                "text": "Poor appetite, trouble sleeping, or difficulty concentrating."
              }
            ],
            "footnote": "These symptoms can have many causes. Only a healthcare professional can assess what they mean for you."
          },
          {
            "type": "bullets",
            "title": "Kidney Tests Your Doctor May Use",
            "items": [
              {
                "title": "eGFR",
                "text": "A blood test that estimates how well your kidneys are filtering."
              },
              {
                "title": "Urine albumin",
                "text": "A urine test that checks for protein, an early sign of kidney damage."
              }
            ]
          },
          {
            "type": "rich_text",
            "title": "Kidney-Friendly Eating",
            "body": "Kidney-friendly eating is individualised. What is right for one person may not be right for another, and it can change as kidney function changes. Speak with your doctor or a registered dietitian about an eating plan built for you rather than following general advice found online."
          },
          {
            "type": "rich_text",
            "title": "Prevention and Management",
            "body": "Managing blood pressure and blood sugar, staying physically active, being careful with over-the-counter medications, and attending regular check-ups all support kidney health. If you already live with kidney disease, keeping to your care plan and appointments is one of the most protective things you can do."
          },
          {
            "type": "cta",
            "title": "Need Support?",
            "text": "If you or a family member is affected by kidney disease, we can share information and current resource guidance.",
            "primary": {
              "label": "Get Support",
              "href": "/get-support"
            },
            "secondary": {
              "label": "Medication Assistance",
              "href": "/medication-assistance"
            }
          }
        ]
      },
      "id": "preview-page-3",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Our Efforts",
      "slug": "our-efforts",
      "page_type": "programs_index",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "seo_title": "Our Efforts & Programs | Bahamas Kidney Association",
      "seo_description": "Medication assistance, patient education and community support, community awareness and screening, and schools and youth engagement across The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Our Efforts",
          "heading_line_1": "Programs That",
          "heading_line_2": "Change Lives.",
          "subheading": "Practical work in communities across The Bahamas."
        },
        "note": "Program availability, medicines, eligibility and capacity can change. Please contact us to confirm current details."
      },
      "id": "preview-page-4",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Medication Assistance",
      "slug": "medication-assistance",
      "page_type": "standard",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/5430213/pexels-photo-5430213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
      "seo_title": "Medication Assistance Program | Bahamas Kidney Association",
      "seo_description": "The Medication Assistance Program helps individuals access the medications they need for kidney care in The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Program",
          "heading_line_1": "Medication",
          "heading_line_2": "Assistance.",
          "subheading": "Helping individuals access the life-saving medications they need."
        },
        "sections": [
          {
            "type": "rich_text",
            "title": "About the Program",
            "body": "The Medication Assistance Program exists because no one should face kidney disease alone. We work to help individuals access the medications that are central to their kidney care."
          },
          {
            "type": "disclaimer",
            "title": "Please Note",
            "body": "Program availability, the medicines covered, eligibility requirements and capacity can change. Specific eligibility criteria and current medicine lists are confirmed by the association and are editable in the CMS. Please contact us to confirm what is available before making plans."
          },
          {
            "type": "rich_text",
            "title": "How to Enquire",
            "body": "Use the Get Support form to tell us what you need. Please do not send detailed medical records through the website. A member of the team will follow up with current guidance."
          },
          {
            "type": "cta",
            "title": "Request Assistance Information",
            "text": "Tell us how we can help and we will respond with current guidance.",
            "primary": {
              "label": "Get Support",
              "href": "/get-support"
            },
            "secondary": {
              "label": "Contact Us",
              "href": "/contact"
            }
          }
        ]
      },
      "id": "preview-page-5",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Get Support",
      "slug": "get-support",
      "page_type": "form_support",
      "status": "published",
      "hero_image_url": "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "seo_title": "Get Support | Bahamas Kidney Association",
      "seo_description": "Request patient and family support information and current resource guidance from the Bahamas Kidney Association.",
      "body_json": {
        "hero": {
          "overline": "Get Support",
          "heading_line_1": "You Are Not",
          "heading_line_2": "Alone In This.",
          "subheading": "Ask for patient and family support information and current resource guidance."
        },
        "intro": "Tell us a little about what you need and we will respond with current information and guidance.",
        "notice": "The Bahamas Kidney Association is not an emergency medical service. If this is a medical emergency, contact your local emergency services or go to the nearest hospital immediately. Please do not upload or send detailed medical records through this form.",
        "support_types": [
          "Patient support information",
          "Family or caregiver support",
          "Medication assistance enquiry",
          "Screening or awareness event",
          "Something else"
        ]
      },
      "id": "preview-page-6",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Get Involved",
      "slug": "get-involved",
      "page_type": "form_volunteer",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "seo_title": "Get Involved | Bahamas Kidney Association",
      "seo_description": "Volunteer, advocate or partner with the Bahamas Kidney Association. Every action matters.",
      "body_json": {
        "hero": {
          "overline": "Get Involved",
          "heading_line_1": "Every Action",
          "heading_line_2": "Matters.",
          "subheading": "Be a volunteer, an advocate or a supporter of kidney health in The Bahamas."
        },
        "intro": "Let us know how you would like to help and we will be in touch.",
        "interests": [
          "Volunteering at events",
          "Community awareness and screening",
          "Schools and youth engagement",
          "Fundraising",
          "Professional or clinical support",
          "Corporate partnership"
        ]
      },
      "id": "preview-page-7",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Research",
      "slug": "research",
      "page_type": "standard",
      "status": "published",
      "hero_image_url": "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "seo_title": "Research | Bahamas Kidney Association",
      "seo_description": "Advancing knowledge for better kidney health in The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Research",
          "heading_line_1": "Advancing Knowledge",
          "heading_line_2": "For Better Health.",
          "subheading": "Building the evidence base for kidney health in The Bahamas."
        },
        "sections": [
          {
            "type": "rich_text",
            "title": "Why Research Matters",
            "body": "Better data on kidney disease in The Bahamas means better prevention, earlier detection and stronger advocacy. We support and share work that helps the country understand and reduce the burden of kidney disease."
          },
          {
            "type": "rich_text",
            "title": "Current Research Activity",
            "body": "Specific research partnerships, studies and publications will be listed here once confirmed by the association. This section is fully editable in the CMS.",
            "placeholder": true
          },
          {
            "type": "cta",
            "title": "Work With Us",
            "text": "If you are a researcher or clinician interested in collaborating, we would like to hear from you.",
            "primary": {
              "label": "Contact Us",
              "href": "/contact"
            }
          }
        ]
      },
      "id": "preview-page-8",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Contact Us",
      "slug": "contact",
      "page_type": "form_contact",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "seo_title": "Contact the Bahamas Kidney Association",
      "seo_description": "Get in touch with the Bahamas Kidney Association by phone, email or through our contact form.",
      "body_json": {
        "hero": {
          "overline": "Contact",
          "heading_line_1": "Let's Talk.",
          "heading_line_2": "",
          "subheading": "We would love to hear from you."
        },
        "intro": "Send us a message and a member of the team will get back to you."
      },
      "id": "preview-page-9",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Testimonials",
      "slug": "testimonials",
      "page_type": "testimonials",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/5727792/pexels-photo-5727792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      "seo_title": "Testimonials | Bahamas Kidney Association",
      "seo_description": "Stories from patients, families, volunteers and healthcare professionals across The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Community Voices",
          "heading_line_1": "What People",
          "heading_line_2": "Are Saying.",
          "subheading": "Stories from patients, families, volunteers and healthcare professionals."
        }
      },
      "id": "preview-page-10",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Blog & News",
      "slug": "blog",
      "page_type": "blog_index",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "seo_title": "Blog & News | Bahamas Kidney Association",
      "seo_description": "Kidney health education, community news and association activities across The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Blog & News",
          "heading_line_1": "News From",
          "heading_line_2": "The Islands.",
          "subheading": "Education, community activity and association updates."
        }
      },
      "id": "preview-page-11",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Emerald Honours",
      "slug": "emerald-honours",
      "page_type": "emerald",
      "status": "published",
      "hero_image_url": "https://images.pexels.com/photos/7005756/pexels-photo-7005756.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
      "seo_title": "Emerald Honours | Bahamas Kidney Association",
      "seo_description": "Emerald Honours celebrates excellence, leadership, service and community impact in kidney health across The Bahamas.",
      "body_json": {
        "hero": {
          "overline": "Emerald Honours",
          "heading_line_1": "Emerald Honours",
          "subheading": "Celebrating excellence, leadership, service and community impact across The Bahamas.",
          "primary_cta": {
            "label": "Submit a Nomination",
            "href": "/emerald-honours/nominate"
          }
        },
        "value_props": [
          {
            "icon": "gem",
            "title": "Recognise Extraordinary People",
            "text": "Honouring those who uplift our communities."
          },
          {
            "icon": "users",
            "title": "Inspire Future Generations",
            "text": "Showcasing role models who create lasting change."
          },
          {
            "icon": "heart",
            "title": "Stronger Communities",
            "text": "Together we build a healthier Bahamas."
          }
        ],
        "overview": {
          "title": "Celebrate Impact",
          "body": "Emerald Honours recognises remarkable individuals, healthcare professionals, organisations and community champions who have made a lasting contribution to kidney health and awareness in The Bahamas."
        },
        "process": [
          {
            "step": "1",
            "title": "Nominate",
            "text": "Submit a nomination telling us about the person or organisation and their impact."
          },
          {
            "step": "2",
            "title": "Review",
            "text": "Each nomination is reviewed by the association."
          },
          {
            "step": "3",
            "title": "Recognition",
            "text": "Approved honourees are celebrated and shared with the community."
          }
        ],
        "faqs": [
          {
            "q": "Who can submit a nomination?",
            "a": "Anyone may submit a nomination. You will be asked for your name, email and phone number so the association can follow up if needed."
          },
          {
            "q": "Can I nominate an organisation?",
            "a": "Yes. Nominations may recognise individuals or organisations, depending on the categories currently open."
          },
          {
            "q": "Is my nomination made public?",
            "a": "No. Nominations are private and are only reviewed by the association. Nothing is published unless it is explicitly approved."
          },
          {
            "q": "When are honourees announced?",
            "a": "Announcement timing is confirmed by the association and will be published here.",
            "placeholder": true
          }
        ],
        "media_heading": "Emerald Honours In Action",
        "honourees_heading": "Past Honourees",
        "honourees_placeholder": "Past honourees will be published here as the association confirms them. This content is managed in the CMS."
      },
      "id": "preview-page-12",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    }
  ],
  "programs": [
    {
      "title": "Medication Assistance Program",
      "summary": "Helping individuals access the life-saving medications they need for kidney care.",
      "body": "The Medication Assistance Program works to help individuals access medications that are central to their kidney care. Program availability, the medicines covered, eligibility requirements and capacity can change, so please contact the association to confirm current details.",
      "image_url": "https://images.pexels.com/photos/5430213/pexels-photo-5430213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
      "icon": "pill",
      "sort_order": 1,
      "id": "preview-program-1",
      "slug": "medication-assistance-program",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Patient Education & Community Support",
      "summary": "Clear information and practical support for patients and the families who care for them.",
      "body": "We provide kidney-health education and community support for people living with kidney disease and their families, including guidance on current resources available in The Bahamas.",
      "image_url": "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "icon": "book-open",
      "sort_order": 2,
      "id": "preview-program-2",
      "slug": "patient-education-community-support",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Community Awareness & Screening",
      "summary": "Taking kidney-health awareness and early detection into communities across the islands.",
      "body": "Community awareness and screening activity brings kidney-health information and early-detection opportunities directly into Bahamian communities. Screening availability and locations vary and are confirmed per event.",
      "image_url": "https://images.pexels.com/photos/913100/pexels-photo-913100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
      "icon": "activity",
      "sort_order": 3,
      "id": "preview-program-3",
      "slug": "community-awareness-screening",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Schools & Youth Engagement",
      "summary": "Building lifelong kidney-health awareness with young Bahamians.",
      "body": "Through schools and youth engagement we work with students and educators to build kidney-health awareness early, including competitions and educational activities.",
      "image_url": "https://images.pexels.com/photos/5727792/pexels-photo-5727792.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
      "icon": "graduation-cap",
      "sort_order": 4,
      "id": "preview-program-4",
      "slug": "schools-youth-engagement",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    }
  ],
  "posts": [
    {
      "title": "5 Ways to Keep Your Kidneys Healthy",
      "category": "Kidney Health",
      "excerpt": "Small, consistent habits protect your kidneys. Here are five places to start, and why each one matters.",
      "body": "Your kidneys work quietly every day, filtering your blood and keeping your body in balance. Looking after them does not require anything dramatic; it mostly comes down to consistency.\n\n**1. Know your blood pressure.** High blood pressure is one of the most common causes of kidney damage. Ask your healthcare provider what your numbers are and what they should be.\n\n**2. Manage blood sugar.** If you live with diabetes, keeping blood sugar within your target range protects the small filters inside your kidneys.\n\n**3. Stay hydrated sensibly.** Water supports kidney function. If you already have kidney disease, ask your doctor how much fluid is right for you rather than following general advice.\n\n**4. Be careful with painkillers.** Regular use of some over-the-counter anti-inflammatory medicines can affect the kidneys. Check with a pharmacist or doctor.\n\n**5. Get checked.** Simple tests such as eGFR and urine albumin can pick up kidney problems early, often before you feel anything.\n\nThis article is general education only and is not medical advice. Please discuss your own kidney health with a qualified healthcare professional.",
      "image_url": "https://images.unsplash.com/photo-1631815590058-860e4f83c1e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
      "id": "preview-post-1",
      "slug": "5-ways-to-keep-your-kidneys-healthy",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "BKA In The Community: A Healthier Bahamas",
      "category": "Community",
      "excerpt": "Awareness activity, screening opportunities and conversations with Bahamians about kidney health.",
      "body": "Community awareness remains at the centre of the association's work. Meeting people where they are, in their own neighbourhoods, is often the first time someone learns that kidney disease can develop quietly for years.\n\nOur community awareness and screening activity focuses on straightforward conversations: what the kidneys do, what raises your risk, and which simple tests can tell you where you stand.\n\nDetails of upcoming community activity are published on this site as they are confirmed. If your organisation, church or community group would like to host an awareness session, please get in touch through the contact form.",
      "image_url": "https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
      "id": "preview-post-2",
      "slug": "bka-in-the-community-a-healthier-bahamas",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    },
    {
      "title": "Honouring Those Who Make A Difference",
      "category": "Emerald Honours",
      "excerpt": "Emerald Honours recognises the individuals and organisations strengthening kidney health across The Bahamas.",
      "body": "Behind every improvement in kidney health there are people: nurses who stay late, community volunteers who set up tables at dawn, families who advocate for a loved one, and organisations that quietly fund what is needed.\n\nEmerald Honours exists to recognise them. Nominations are open to anyone who wants to put forward an individual or organisation making a lasting contribution to kidney health and awareness in The Bahamas.\n\nEvery nomination is reviewed by the association, and nothing is published unless it has been explicitly approved. If someone comes to mind as you read this, that is exactly who the nomination form is for.",
      "image_url": "https://images.pexels.com/photos/7005756/pexels-photo-7005756.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
      "id": "preview-post-3",
      "slug": "honouring-those-who-make-a-difference",
      "status": "published",
      "published_at": "2026-09-01T12:00:00+00:00",
      "created_at": "2026-09-01T12:00:00+00:00",
      "updated_at": "2026-09-01T12:00:00+00:00"
    }
  ],
  "testimonials": [],
  "emeraldMedia": [],
  "emeraldConfig": {
    "nominations_open": true,
    "closed_message": "",
    "categories": [
      {
        "id": "healthcare-professional",
        "label": "Healthcare Professional"
      },
      {
        "id": "community-champion",
        "label": "Community Champion"
      },
      {
        "id": "patient-advocate",
        "label": "Patient Advocate"
      },
      {
        "id": "volunteer",
        "label": "Volunteer"
      },
      {
        "id": "organization",
        "label": "Organization"
      }
    ]
  }
};

export function ftpPreviewResponse(url = "", params = {}) {
  const clean = String(url || "").split("?")[0].replace(/^\/+/, "");
  const data = FTP_PREVIEW_DATA;

  if (clean === "public/bootstrap") {
    return {
      settings: data.settings,
      nav: data.nav,
      donation_configured: Boolean((data.settings["donations.fygaro_url"] || "").trim()),
      staging_noindex: true,
      preview_mode: true,
    };
  }

  if (clean.startsWith("public/pages/")) {
    const slug = decodeURIComponent(clean.slice("public/pages/".length));
    return data.pages.find((p) => p.slug === slug && p.status === "published") || null;
  }

  if (clean === "public/programs") return data.programs.filter((p) => p.status === "published");
  if (clean.startsWith("public/programs/")) {
    const slug = decodeURIComponent(clean.slice("public/programs/".length));
    return data.programs.find((p) => p.slug === slug && p.status === "published") || null;
  }

  if (clean === "public/posts") {
    let items = data.posts.filter((p) => p.status === "published");
    if (params?.category) items = items.filter((p) => p.category === params.category);
    const limit = Math.max(1, Math.min(Number(params?.limit || 24), 60));
    return items.slice(0, limit);
  }
  if (clean.startsWith("public/posts/")) {
    const slug = decodeURIComponent(clean.slice("public/posts/".length));
    const post = data.posts.find((p) => p.slug === slug && p.status === "published");
    if (!post) return null;
    return {
      post,
      related: data.posts.filter((p) => p.status === "published" && p.slug !== slug && p.category === post.category).slice(0, 3),
    };
  }

  if (clean === "public/testimonials") return data.testimonials;
  if (clean === "public/emerald/media") return data.emeraldMedia;
  if (clean === "public/emerald/config") return data.emeraldConfig;
  if (clean === "public/donate") {
    const url = (data.settings["donations.fygaro_url"] || "").trim();
    return { configured: /^https:\/\//i.test(url), url: /^https:\/\//i.test(url) ? url : null };
  }
  if (clean === "public/redirect") return { to: null };
  return undefined;
}
